export type TierName = 'trial' | 'starter' | 'pro';

export interface TierLimits {
  maxInspirationSources: number;
  maxCompetitors: number;
  monthlyInspirationAdds: number;
  monthlyCompetitorAdds: number;
  monthlyBasicGenerations: number;
  monthlyEnhancedGenerations: number;
}

export const TIER_LIMITS: Record<TierName, TierLimits> = {
  trial: {
    maxInspirationSources: 1,
    maxCompetitors: 1,
    monthlyInspirationAdds: 1,
    monthlyCompetitorAdds: 1,
    monthlyBasicGenerations: 5,
    monthlyEnhancedGenerations: 5,
  },
  starter: {
    maxInspirationSources: 3,
    maxCompetitors: 3,
    monthlyInspirationAdds: 3,
    monthlyCompetitorAdds: 3,
    monthlyBasicGenerations: 15,
    monthlyEnhancedGenerations: 5,
  },
  pro: {
    maxInspirationSources: 6,
    maxCompetitors: 6,
    monthlyInspirationAdds: 12,
    monthlyCompetitorAdds: 12,
    monthlyBasicGenerations: 60,
    monthlyEnhancedGenerations: 30,
  },
};
